import { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Fade } from '@mui/material';
import { useLocation } from 'react-router-dom';

import Nav from './nav';
import Main from './main';
import Header from './header';

export default function DashboardLayout({ children }) {
  const [openNav, setOpenNav] = useState(false);
  const location = useLocation();

  return (
    <Box display="flex" flexDirection="column" minHeight="100vh"> {/* ✅ enforce full screen height */}
      <Header onOpenNav={() => setOpenNav(true)} />

      <Box
        sx={{
          flex: 1, // ✅ allows content area to grow and fill height
          display: 'flex',
          flexDirection: { xs: 'column', lg: 'row' },
        }}
      >
        <Nav openNav={openNav} onCloseNav={() => setOpenNav(false)} />

        {/* Smooth page transition */}
        <Main>
          <Fade in={true} key={location.pathname} timeout={300}>
            <Box sx={{ flexGrow: 1 }}>{children}</Box>
          </Fade>
        </Main>
      </Box>
    </Box>
  );
}

DashboardLayout.propTypes = {
  children: PropTypes.node,
};
